'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SessionExpiredDialog = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _InfoDialog = require('@rio-cloud/rio-uikit/lib/es/InfoDialog');

var _InfoDialog2 = _interopRequireDefault(_InfoDialog);

var _lang = require('./lang');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SessionExpiredDialog = exports.SessionExpiredDialog = function SessionExpiredDialog(_ref) {
    var className = _ref.className,
        disableEsc = _ref.disableEsc,
        locale = _ref.locale,
        onClose = _ref.onClose,
        onConfirm = _ref.onConfirm,
        show = _ref.show;

    var supportedLocale = (0, _lang.getSupportedLocale)(locale);
    var messages = (0, _lang.getDisplayMessages)(supportedLocale);
    return _react2.default.createElement(
        _reactIntl.IntlProvider,
        { defaultLocale: _lang.DEFAULT_LOCALE, key: supportedLocale, locale: supportedLocale, messages: messages },
        _react2.default.createElement(_InfoDialog2.default, {
            className: className,
            content: _react2.default.createElement(
                'div',
                { className: 'text-center' },
                _react2.default.createElement(
                    'div',
                    { className: 'margin-bottom-25' },
                    _react2.default.createElement(
                        'h2',
                        { className: 'margin-bottom-25' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'heading' })
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'margin-0 text-size-large' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'reason' })
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'margin-0 text-size-large' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'whatToDo' })
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'margin-bottom-0 text-size-small' },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'btn btn-link btn-link-inline text-size-small',
                                onClick: onClose,
                                type: 'button'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'close' })
                        )
                    )
                ),
                _react2.default.createElement(
                    'a',
                    { className: 'btn btn-primary margin-bottom-20', href: '/', onClick: onConfirm },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login' })
                )
            ),
            disableEsc: disableEsc,
            onClose: onClose,
            show: show
        })
    );
};

SessionExpiredDialog.defaultProps = {
    className: '',
    onConfirm: function onConfirm(ev) {
        if (ev && ev.preventDefault) {
            ev.preventDefault();
        }

        window.location.reload();
    }
};

SessionExpiredDialog.propTypes = {
    className: _propTypes2.default.string,
    disableEsc: _propTypes2.default.bool,
    locale: _propTypes2.default.string.isRequired,
    onClose: _propTypes2.default.func.isRequired,
    onConfirm: _propTypes2.default.func,
    show: _propTypes2.default.bool.isRequired
};